module.exports = __webpack_public_path__ + "img/single_pictures_5.0328b952.jpg";